import { memo } from 'react';

function ApprovalsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#637381"
        d="M19.958 13.306l-5.685-1.896V6.863l1.896-.633a.818.818 0 00.558-.775V3H6.91v2.455c0 .351.225.664.559.775l1.896.633v4.548l-5.686 1.895A2.453 2.453 0 002 15.634v2.093h19.636v-2.094a2.453 2.453 0 00-1.678-2.327z"
        opacity="0.32"
      />
      <path fill="#637381" d="M20 19.364H3.637V21H20v-1.636z" />
    </svg>
  );
}

export default memo(ApprovalsIcon);
